(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  function openCart() { if (drawer) { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.hidden = true; document.documentElement.style.overflow = ''; } }

  function refresh() {
    return fetch(window.location.pathname + '?v=' + Date.now(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('.cart-count');
        if (count) {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count.textContent; });
        }
        openCart();
      });
  }

  function addToCart(id, qty) {
    var body = new URLSearchParams();
    body.append('id', id);
    body.append('quantity', qty || 1);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json' },
      body: body.toString()
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink) { e.preventDefault(); openCart(); return; }

    var rm = t.closest('[data-cart-items] a[href*="/cart/change"]');
    if (rm) { e.preventDefault(); fetch(rm.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(refresh); return; }

    var up = t.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      var id = up.getAttribute('data-variant');
      if (!id) { openCart(); return; }
      var label = up.textContent;
      up.setAttribute('aria-busy', 'true');
      up.textContent = 'Claiming…';
      addToCart(id, 1)
        .then(refresh)
        .catch(function (err) {
          up.textContent = label;
          up.removeAttribute('aria-busy');
          var msg = up.parentNode.querySelector('.offer__err');
          if (!msg) { msg = document.createElement('small'); msg.className = 'offer__err'; up.parentNode.appendChild(msg); }
          msg.textContent = err.message;
        });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // Bundle tiers + quantity
  var qtyInput = document.querySelector('[data-qty-input]');
  function setQty(n) {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, n);
    document.querySelectorAll('.tier').forEach(function (t) {
      t.classList.toggle('is-on', Number(t.dataset.qty) === Number(qtyInput.value));
    });
  }
  if (qtyInput) qtyInput.addEventListener('change', function () { setQty(Number(qtyInput.value)); });
  document.querySelectorAll('.tier').forEach(function (t) {
    t.addEventListener('click', function () { setQty(Number(t.dataset.qty)); });
  });
  var minus = document.querySelector('[data-qty-minus]');
  var plus = document.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () { setQty(Number(qtyInput.value) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(Number(qtyInput.value) + 1); });

  // Add to cart -> popup
  var form = document.getElementById('BuyForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(refresh)
        .catch(function () { openCart(); })
        .finally(function () { if (btn) btn.textContent = 'Add to cart'; });
    });
  }

  var mAdd = document.querySelector('[data-mbar-add]');
  if (mAdd) mAdd.addEventListener('click', function () {
    if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    else openCart();
  });

  // Daily-resetting countdown
  var el = document.querySelector('[data-countdown]');
  if (el) {
    var resetHour = parseInt(el.getAttribute('data-reset-hour') || '0', 10);
    var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var now = new Date();
      var next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), resetHour, 0, 0, 0);
      if (next <= now) next.setDate(next.getDate() + 1);
      var d = Math.max(0, Math.floor((next - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600));
      m.textContent = pad(Math.floor((d % 3600) / 60));
      s.textContent = pad(d % 60);
    };
    tick();
    setInterval(tick, 1000);
  }
})();
